"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.canAccessTestimonialsNav = exports.isNonSSTMembershipType = exports.isFullMembershipType = exports.isBasicMembershipType = exports.isShoreBasedMembershipType = exports.isPartnerMembershipType = exports.getMembershipDisplayStatus = exports.MEMBERSHIP_DISPLAY_STATUS = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var MembershipStatus_1 = require("../MembershipStatus");
var const_1 = require("../const");
/**
 * Display status for memberships in the UI
 * - ACTIVE: Currently active membership (IssueDate <= now <= ExpireDate)
 * - SCHEDULED: Future membership that hasn't started yet (IssueDate > now)
 * - EXPIRED: Membership that has ended (ExpireDate < now)
 * - UNPAID: Membership that hasn't been paid yet
 */
var MEMBERSHIP_DISPLAY_STATUS;
(function (MEMBERSHIP_DISPLAY_STATUS) {
    MEMBERSHIP_DISPLAY_STATUS["ACTIVE"] = "Active";
    MEMBERSHIP_DISPLAY_STATUS["SCHEDULED"] = "Scheduled";
    MEMBERSHIP_DISPLAY_STATUS["EXPIRED"] = "Expired";
    MEMBERSHIP_DISPLAY_STATUS["UNPAID"] = "Unpaid";
})(MEMBERSHIP_DISPLAY_STATUS || (exports.MEMBERSHIP_DISPLAY_STATUS = MEMBERSHIP_DISPLAY_STATUS = {}));
/**
 * Determines the display status for a membership based on its dates and payment status
 * @param membership The membership object with IssueDate, ExpireDate, and Status
 * @returns The display status enum value
 */
var getMembershipDisplayStatus = function (membership) {
    var now = (0, dayjs_1.default)();
    var issueDate = membership.IssueDate ? (0, dayjs_1.default)(membership.IssueDate) : null;
    var expireDate = membership.ExpireDate ? (0, dayjs_1.default)(membership.ExpireDate) : null;
    // If not paid, show unpaid
    if (membership.Status !== MembershipStatus_1.MEMBERSHIP_STATUS.PAID) {
        return MEMBERSHIP_DISPLAY_STATUS.UNPAID;
    }
    // If no dates, treat as unpaid
    if (!issueDate || !expireDate) {
        return MEMBERSHIP_DISPLAY_STATUS.UNPAID;
    }
    // If issue date is in the future, it's scheduled
    if (issueDate.isAfter(now)) {
        return MEMBERSHIP_DISPLAY_STATUS.SCHEDULED;
    }
    // If expire date is in the past, it's expired
    if (expireDate.isBefore(now)) {
        return MEMBERSHIP_DISPLAY_STATUS.EXPIRED;
    }
    // Otherwise it's active (IssueDate <= now <= ExpireDate)
    return MEMBERSHIP_DISPLAY_STATUS.ACTIVE;
};
exports.getMembershipDisplayStatus = getMembershipDisplayStatus;
/**
 * Checks if a membership type is a partner type based on its TypeSlug
 * Partner memberships have TypeSlug starting with 'partner-'
 * @param typeSlug The TypeSlug of the membership rate
 * @returns true if the membership is a partner type
 */
var isPartnerMembershipType = function (typeSlug) {
    if (!typeSlug)
        return false;
    return typeSlug.toLowerCase().startsWith(const_1.PARTNER_MEMBERSHIP_PREFIX);
};
exports.isPartnerMembershipType = isPartnerMembershipType;
var isShoreBasedMembershipType = function (membershipType, membershipTypeSlug) {
    if ((membershipTypeSlug === null || membershipTypeSlug === void 0 ? void 0 : membershipTypeSlug.toLowerCase()) === const_1.SHORE_BASED_MEMBERSHIP_SLUG)
        return true;
    return membershipType === const_1.SHORE_BASED_MEMBER_RATE;
};
exports.isShoreBasedMembershipType = isShoreBasedMembershipType;
var isBasicMembershipType = function (membershipType, membershipTypeSlug) {
    if ((membershipTypeSlug === null || membershipTypeSlug === void 0 ? void 0 : membershipTypeSlug.toLowerCase()) === const_1.BASIC_MEMBERSHIP_SLUG)
        return true;
    return membershipType === const_1.BASIC_MEMBERSHIP_RATE;
};
exports.isBasicMembershipType = isBasicMembershipType;
var isFullMembershipType = function (membershipType, membershipTypeSlug) {
    if ((membershipTypeSlug === null || membershipTypeSlug === void 0 ? void 0 : membershipTypeSlug.toLowerCase()) === const_1.FULL_MEMBER_SLUG)
        return true;
    return membershipType === const_1.FULL_MEMBER_RATE;
};
exports.isFullMembershipType = isFullMembershipType;
var isNonSSTMembershipType = function (membershipType, membershipTypeSlug) {
    if ((0, exports.isShoreBasedMembershipType)(membershipType, membershipTypeSlug))
        return true;
    return (0, exports.isBasicMembershipType)(membershipType, membershipTypeSlug);
};
exports.isNonSSTMembershipType = isNonSSTMembershipType;
var canAccessTestimonialsNav = function (membershipType, membershipTypeSlug) {
    return !(0, exports.isShoreBasedMembershipType)(membershipType, membershipTypeSlug);
};
exports.canAccessTestimonialsNav = canAccessTestimonialsNav;
//# sourceMappingURL=membershipUtils.js.map